import { render } from "./ArchivedCohortBanner.vue?vue&type=template&id=6e47a780"
import script from "./ArchivedCohortBanner.vue?vue&type=script&lang=js"
export * from "./ArchivedCohortBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__